<template>
  <Modal :title="title" :showModal="showModal" class="edit-supplier-account-form" @submit="submit">
    <template v-slot:body>
      <component :is="modal" :config="modalConfig()" @close="$emit('close', $event)"></component>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      modal: 'Black'
    }
  },
  computed: {
    title() {
      return 'Edit Supplier Account'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.data?._id
    },
    getUri() {
      return `supplier-account/get/${this.accountId}`
    },
    submitUri() {
      return `supplier-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    modalConfig() {
      return {
        action: this.action,
        storeId: this.storeId,
        accountId: this.accountId
      }
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        let platform = _.pascalCase(rawData.data.platform || '')
        let action = _.pascalCase(this.action)
        let modal = `${platform}.SupplierAccount.${action}`
        if (this.$options.components[modal] == undefined) {
          this.$options.components[modal] = this.$util.requireOrNull(`/platforms/${platform}/SupplierAccount/Modal/${action}.vue`)
        }
        if (!_.isUndefined(rawData.data.platform) && this.$options.components[modal] !== null) {
          this.showModal = true
          rawData.data.meta = Object.assign({}, rawData.data.meta)
          this.store.commit('', rawData.data)
          this.modal = modal
        } else {
          this.$emit('close')
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }
      }
    },
    submit() {
      this.$emitter.emit('Modal.SupplierAccount.Edit.Submit', this.data)
    }
  },
  props: {
    config: Object
  }
}
</script>
